import { getAll as getAllFactureAchat } from '@/api/factureAchat';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllFactureVente } from '@/api/facture';
import { TYPE_REFERENCE_EXTERNE_ACHAT, TYPE_REFERENCE_EXTERNE_VENTE } from '@/configuration/dcf/dcfConf';
import { ETAT_BROUILLON, SENS_VENTE } from '@/configuration/devisConf';

function findSocieteId(intervenants, societesTiers) {
  const payeur = intervenants.find((i) => i.payeur);
  if (!payeur) return null;
  const societeTiersFind = societesTiers.find((s) => {
    return s.fournisseurId === payeur.tiersId;
  });
  return societeTiersFind ? societeTiersFind.societeId : null;
}

export default async function loadFactureAchatVenteInterne(
  facture, societesTiers, loadFactureVenteInterne = true,
) {
  const facturesAchat = (await getAllFactureAchat({
    limit: NO_PAGINATION,
    query: {
      sousType: [facture.sousType],
      referenceExterne: facture.id,
      societeId: facture.societeId,
      typeReferenceExterne: TYPE_REFERENCE_EXTERNE_VENTE,
    },
  })).data.result.items;
  if (!loadFactureVenteInterne) return facturesAchat;
  const promiseFactureVente = [];
  facturesAchat.forEach((f) => {
    f.selected = false;
    f.factureVenteInterne = null;
    if (f.etat === ETAT_BROUILLON) return;
    const societeId = findSocieteId(f.intervenants, societesTiers);
    if (!societeId) return;
    promiseFactureVente.push(getAllFactureVente({
      limit: NO_PAGINATION,
      query: {
        referenceExterne: f.id,
        societeId: societeId,
        typeReferenceExterne: TYPE_REFERENCE_EXTERNE_ACHAT,
        sens: SENS_VENTE,
      },
    }));
  });
  const rsltPromise = await Promise.all(promiseFactureVente);
  rsltPromise.forEach((rslt) => {
    const factures = rslt.data.result.items;
    if (factures.length === 0) return;
    const factureAchat = facturesAchat.find((c) => c.id === factures[0].referenceExterne);
    if (!factureAchat) return;
    factureAchat.factureVenteInterne = factures[0];
  });
  return facturesAchat;
}
